<template>
  <!-- 加购成功弹窗：Detail / List 共用；info 为加购接口返回的购物车信息，展示与关闭时机由父级控制 -->
  <div class="dialog cart-dialog" v-if="info">
    <div class="dialog-container" :style="containerStyle">
      <div class="dialog-header">
        <button class="dialog-close" @click="$emit('close')">
          <span class="close-icon"></span>
        </button>
      </div>
      <div class="dialog-body">
        <div class="body-main">
          <div class="item-detail">
            <h2 class="title">已加入购物车</h2>
            <div class="item-info">
              <img :src="info.info.cover" />
              <div class="pdp-detail">
                <div class="item-detail-brand" v-if="info.info.brand && info.info.brand.name">{{
                  info.info.brand.name }}</div>
                <div class="item-name">{{ info.info.name }}</div>
                <template v-if="Array.isArray(info.info.custom_tags) && calcIsShowCustomerTag && info.info.custom_tags">
                  <div v-for="(label, index) in info.info.custom_tags" :key="'custom' + index"
                    class="item-tag custom-tags">
                    {{ label }}
                  </div>
                </template>
                <div class="item-attr">
                  <span class="attr-name">颜色</span>:
                  <span class="attr-value">{{ info.info.color.name }}</span>
                </div>
                <div class="item-attr">
                  <span class="attr-name">尺码</span>:
                  <span class="attr-value">{{ info.info.size.name }}</span>
                </div>
                <!-- 原价展示与 ListItem 口径一致：有原价且 gw_md 开启时展示现价+划线原价 -->
                <template v-if="isShowOriginalPrice(info.info) && isGwMdEnablePoint">
                  <div class="item-price has-original_price">
                    <span class="rmb-symbol">￥</span>{{ info.info.price }}
                    <span class="item-original_price">
                      <span class="rmb-symbol">￥{{ info.info.original_price }}</span>
                    </span>
                  </div>
                </template>
                <template v-else>
                  <div class="item-price">
                    <span class="rmb-symbol">￥</span>{{ info.info.price }}
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="cart-detail">
            <h2 class="title">订单小计</h2>
            <div class="cart-subtotal">
              <span class="rmb-symbol">￥</span>{{ info.subTotal }}
            </div>
            <button class="checkout" @click="$emit('checkout')">立即结算</button>
            <button class="view-cart" @click="$emit('cart')">查看购物车</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/utils";

export default {
  name: "CartSuccessDialog",
  props: {
    // 加购接口返回的购物车信息 { info: { name, cover, color, size, price... }, subTotal }
    info: Object,
    // 弹层顶部偏移：Detail 传 headerHeight 吸顶栏下方，缺省走样式固定值（List 场景）
    headerHeight: {
      type: Number,
      default: 0
    },
    // 是否允许显示原价（弹窗属购物车场景，与 Cart 页口径一致）
    isGwMdEnablePoint: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    containerStyle() {
      return this.headerHeight > 0 ? { top: this.headerHeight + 'px' } : null;
    },
    // 新客标签展示开关
    calcIsShowCustomerTag() {
      return this.$store.state.isShowCustomerTag;
    },
  },
  methods: {
    isShowOriginalPrice: utils.isShowOriginalPrice,
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  .dialog-container {
    box-sizing: border-box;
    position: fixed;
    z-index: 1011;
    background: #FFF;
    border-radius: 0;
  }

  .dialog-header {
    position: relative;
    text-align: left;

    .dialog-close {
      width: 32px;
      height: 32px;
      position: absolute;
      top: 10px;
      right: 10px;
      padding: 0;
      border: none;
      border-radius: 0;
      margin: 0;
      background-color: transparent;
      font-size: 0;
      cursor: pointer;

      .close-icon {
        background-image: url(../assets/imgs/icons/onitsukatiger-close2.svg);
        background-position: center center;
        background-repeat: no-repeat;
        height: 32px;
        width: 32px;
        margin: 0;
        padding: 0;
        display: block;
        text-indent: -99999px;
        overflow: hidden;
      }
    }
  }

  .dialog-body {
    box-sizing: border-box;
    display: flex;
    padding: 30px 20px;

    .body-main {
      display: flex;
      width: 100%;
      max-width: 1025px;
      margin: 0 auto;

      .item-detail {
        box-sizing: border-box;
        width: 50%;
        padding-right: 10px;
        text-align: left;

        .item-info {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          img {
            width: 120px;
            height: 120px;
          }

          .pdp-detail {
            margin-left: calc(1.1875rem * 1.6);

            .item-detail-brand {
              color: #BABEC2;
              font-weight: 700;
              font-size: 15px;
              margin-bottom: 10px;
            }

            .item-name {
              font-weight: 400;
              font-size: calc(1rem * 1.6);
              line-height: calc(1.375rem * 1.6);
              letter-spacing: 0.025em;
              color: #000;
            }

            .item-tag {
              font-size: 10px;
              border: 1px solid #212322;
              padding: 0px 5px;
              margin: 4px 0;
              line-height: 18px;
              color: #212322;
              width: fit-content;
            }

            .item-attr {
              text-align: left;
              line-height: 24px;

              .attr-name {
                font-weight: 400;
                font-size: calc(0.8125rem * 1.6);
                color: #000;
              }

              .attr-value {
                font-weight: 400;
                font-size: calc(0.8125rem * 1.6);
                color: #000;
              }
            }

            .item-price {
              font-weight: 400;
              font-size: calc(1.125rem * 1.6);
              line-height: 24px;
              color: #000;

              // 与 ListItem 的现价+划线原价样式保持一致
              &.has-original_price {
                color: #212322;
                font-weight: 700;

                .item-original_price {
                  margin-left: 8px;
                  color: #4d4d4c;
                  font-weight: 400;
                  text-decoration: line-through;
                }
              }
            }
          }
        }
      }

      .cart-detail {
        box-sizing: border-box;
        width: 50%;
        padding-left: calc(3.0625rem * 1.6);
        border-left: 1px solid #b4b5b4;
        text-align: center;

        .cart-subtotal {
          font-weight: 400;
          line-height: calc(1.5rem * 1.6);
          font-size: calc(1.5rem * 1.6);
          color: #000;
        }

        .checkout {
          display: block;
          box-sizing: border-box;
          max-width: 285px;
          margin: 10px auto 0;
          cursor: pointer;
          line-height: 38px;
          padding: 0 30px;
          font-weight: 400;
          font-size: calc(0.875rem * 1.6);
          letter-spacing: normal;
          border-radius: 2px;
          text-align: center;
          text-decoration: none;
          text-transform: uppercase;
          transition: all 0.3s ease;
          color: #fff;
          background-color: #7f0019;
          border: 1px solid #7f0019;
        }

        .view-cart {
          display: block;
          line-height: calc(1.375rem * 1.6);
          font-size: calc(0.875rem * 1.6);
          font-weight: 400;
          color: #000;
          margin: 12px auto 0;
          cursor: pointer;
          text-align: center;
          background: transparent;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      .title {
        display: block;
        font-weight: 400;
        font-size: calc(1.625rem * 1.6);
        line-height: calc(1.625rem * 1.6);
        letter-spacing: 0.05em;
        margin: 0 0 25px;
        text-align: center;
        color: #000;
      }
    }
  }

  // PC：通栏横条吸在 header 下方（z-index 低于 header 1000，遮罩除外）
  .dialog-container {
    top: 156px;
    left: 0;
    z-index: 991; //低于header1000
    width: 100%;
    max-width: 100%;
    min-height: 235px;
    transform: translate(0, 0);
  }
}

@media only screen and (max-width: 1024px) {
  .dialog {
    .dialog-container {
      top: 82px;
      z-index: 1000;
    }
  }
}

@media only screen and (max-width: 768px) {
  .dialog {
    .dialog-container {
      position: fixed;

      .dialog-body {
        .body-main {
          flex-direction: column;

          .item-detail {
            width: 100%;
            padding-right: 0;
            padding-bottom: 20px;

            .title {
              font-size: 20px;
            }
          }

          .cart-detail {
            width: 100%;
            padding-left: 0;
            padding-top: 20px;
            border-left: none;
            border-top: 1px solid #b4b5b4;

            .title {
              font-size: 20px;
            }

            .cart-subtotal {
              font-size: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
